export const translations = {
  en: {
    nav: { home: 'Home', services: 'Services', areas: 'Areas', how: 'How It Works', faq: 'FAQ', contact: 'Contact', startBond: 'Start a Bond', signIn: 'Staff Sign In' },
    utility: { help247: '24/7 Bail Bond Help', trust: 'Fast, confidential help', text: 'Text an Agent' },
    hero: { badge: '24/7 · Bilingual · Montgomery County', callNow: 'Call Now', startBond: 'Start a Bond', scroll: 'Scroll' },
    common: {
      callNow: 'Call Now', startBond: 'Start a Bond', learnMore: 'Learn More', viewAll: 'View All', readMore: 'Read More',
      submit: 'Submit', next: 'Continue', back: 'Back', required: 'Required', optional: 'Optional',
      loading: 'Loading...', locateInmate: 'Locate an Inmate', paymentOptions: 'Get Payment Options',
      requestCallback: 'Request a Callback', talkToAgent: 'Hablar con un Agente',
    },
    footer: {
      nav: 'Navigation', resources: 'Resources', contact: 'Contact', legal: 'Legal',
      desc: "Fast, confidential 24/7 bail bond help for Montgomery County, Texas. Se habla Español.",
      rights: 'All rights reserved.', credit: 'Developed by James Hudson @ Texas IT Nerds | Protected by TITN Aegis Security',
      privacy: 'Privacy Policy', dataPolicy: 'Data Collection Policy',
    },
  },
  es: {
    nav: { home: 'Inicio', services: 'Servicios', areas: 'Áreas', how: 'Cómo Funciona', faq: 'Preguntas', contact: 'Contacto', startBond: 'Iniciar Fianza', signIn: 'Acceso del Personal' },
    utility: { help247: 'Ayuda de Fianzas 24/7', trust: 'Ayuda rápida y confidencial', text: 'Enviar Mensaje' },
    hero: { badge: '24/7 · Bilingüe · Condado de Montgomery', callNow: 'Llamar Ahora', startBond: 'Iniciar Fianza', scroll: 'Desliza' },
    common: {
      callNow: 'Llamar Ahora', startBond: 'Iniciar Fianza', learnMore: 'Conocer Más', viewAll: 'Ver Todas', readMore: 'Leer Más',
      submit: 'Enviar', next: 'Continuar', back: 'Atrás', required: 'Requerido', optional: 'Opcional',
      loading: 'Cargando...', locateInmate: 'Buscar a un Detenido', paymentOptions: 'Ver Opciones de Pago',
      requestCallback: 'Solicitar una Llamada', talkToAgent: 'Hablar con un Agente',
    },
    footer: {
      nav: 'Navegación', resources: 'Recursos', contact: 'Contacto', legal: 'Legal',
      desc: 'Ayuda de fianzas rápida y confidencial, 24/7, para el Condado de Montgomery, Texas. Se habla Español.',
      rights: 'Todos los derechos reservados.', credit: 'Desarrollado por James Hudson @ Texas IT Nerds | Protegido por TITN Aegis Security',
      privacy: 'Política de Privacidad', dataPolicy: 'Política de Datos',
    },
  },
};
